import * as prompts from './prompts';
import { supabase } from '../../lib/supabase';

const IS_LOCALHOST = window.location.hostname.includes('localhost');

const modelInfo = {
    'qwen2.5:72b': {
        uri: 'http://localhost:3000/api/chat/completions',
        name: 'Qwen 2.5',
    },
    'gemma3:27b': {
        uri: 'http://localhost:3000/api/chat/completions',
        name: 'Gemma 3',
    },
    'claude-sonnet-4-5-20250929': {
        uri: IS_LOCALHOST ? 'http://localhost:8787/llm' : 'https://manichi-api.lucas-ae7.workers.dev/llm',
        name: 'Claude 3.7',
    },
    'claude-sonnet-4-6': {
        uri: IS_LOCALHOST ? 'http://localhost:8787/llm' : 'https://manichi-api.lucas-ae7.workers.dev/llm',
        name: 'Claude Sonnet 4',
    },
};

export const models = Object.entries(modelInfo).map(([key, value]) => ({
    id: key,
    ...value,
}));
export type Models = keyof typeof modelInfo;

export const sentenceCorrector = async (input: string, model: Models) => {
    const m = modelInfo[model];
    if (!m) {
        throw new Error(`Model ${model} not supported`);
    }

    const {
        data: { session },
    } = await supabase.auth.getSession();
    const authToken = session?.access_token;

    const response = await fetch(m.uri, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': authToken,
        },
        body: JSON.stringify({
            model,
            messages: [
                {
                    role: 'system',
                    content: prompts.sentenceCorrectorTwo,
                },
                {
                    role: 'user',
                    content: input,
                },
            ],
        }),
    });

    const data = await response.json();
    return data.choices[0].message.content;
};
